(function () {
  'use strict';

  if (window.ProductUI2026) return;
  var instances = new Map();

  function initPopups(root, state) {
    if (!window.ProductDialog) return;
    var sizing = root.querySelector('dialog.product-info-all-popups');
    var faq = root.querySelector('dialog.product-specific-popup');
    var sizingModal = sizing ? window.ProductDialog.mount(sizing) : null;
    var faqModal = faq ? window.ProductDialog.mount(faq) : null;
    state.sizingModal = sizingModal;
    [sizingModal, faqModal].forEach(function (modal) { if (modal) state.cleanups.push(modal.destroy); });
    root.addEventListener('click', function (event) {
      var trigger = event.target.closest('.popup-trigger, .faq-card');
      if (!trigger) return;
      if (trigger.matches('.faq-card')) faqModal?.open(trigger);
      else if (trigger.dataset.target === 'size-guide') sizingModal?.open(trigger);
    }, { signal: state.controller.signal });
    if (!faq) return;
    var tabs = Array.from(faq.querySelectorAll('[role="tab"]'));
    function selectTab(tab, focus) {
      tabs.forEach(function (item) {
        var selected = item === tab;
        item.setAttribute('aria-selected', String(selected));
        item.tabIndex = selected ? 0 : -1;
        item.classList.toggle('active', selected);
        var panel = document.getElementById(item.getAttribute('aria-controls'));
        if (panel) panel.hidden = !selected;
      });
      if (focus) tab.focus();
    }
    tabs.forEach(function (tab, index) {
      tab.addEventListener('click', function () { selectTab(tab); }, { signal: state.controller.signal });
      tab.addEventListener('keydown', function (event) {
        var next;
        if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
        if (event.key === 'ArrowLeft') next = (index + tabs.length - 1) % tabs.length;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = tabs.length - 1;
        if (next === undefined) return;
        event.preventDefault(); selectTab(tabs[next], true);
      }, { signal: state.controller.signal });
    });
    if (tabs.length) selectTab(tabs[0]);
  }

  function updateAccordionClasses(root) {
    root.querySelectorAll('.prod__accordian-main.__overlapped').forEach(function (container) {
      var count = container.querySelectorAll(':scope > .prod__accordian').length;
      container.classList.toggle('__has-2', count === 2);
      container.classList.toggle('__has-3', count === 3);
    });
  }

  function initAccordions(root, state) {
    root.querySelectorAll('.prod__accordian_header').forEach(function (header, index) {
      header.setAttribute('role', 'button');
      header.setAttribute('tabindex', '0');
      header.setAttribute('aria-expanded', 'false');
      var panel = header.closest('.prod__accordian')?.querySelector('.prod__accordian_content');
      if (panel) {
        panel.id = 'product-accordion-' + root.dataset.sectionId + '-' + index;
        panel.hidden = true;
        header.setAttribute('aria-controls', panel.id);
      }

      function toggle() {
        var item = header.closest('.prod__accordian');
        if (!item) return;
        var content = item.querySelector('.prod__accordian_content');
        var open = !item.classList.contains('prod__accordian--active');

        root.querySelectorAll('.prod__accordian').forEach(function (other) {
          other.classList.remove('prod__accordian--active');
          other.querySelector('.prod__accordian_header')?.setAttribute('aria-expanded', 'false');
          var otherContent = other.querySelector('.prod__accordian_content');
          if (otherContent) {
            otherContent.hidden = true;
            otherContent.style.display = 'none';
          }
        });

        item.classList.toggle('prod__accordian--active', open);
        if (content) {
          content.hidden = !open;
          content.style.display = open ? 'block' : 'none';
        }
        header.setAttribute('aria-expanded', String(open));
      }

      header.addEventListener('click', toggle, { signal: state.controller.signal });
      header.addEventListener('keydown', function (event) {
        if (header.tagName !== 'BUTTON' && (event.key === 'Enter' || event.key === ' ')) {
          event.preventDefault();
          toggle();
        }
      }, { signal: state.controller.signal });
    });
    updateAccordionClasses(root);
  }

  function differentPlacement(previous) {
    var placements = ['top', 'bottom', 'top-right', 'bottom-left'].filter(function (placement) {
      return placement !== previous;
    });
    return placements[Math.floor(Math.random() * placements.length)];
  }

  function showPlacement(wrapper, placement) {
    wrapper.querySelectorAll('.x-line-container').forEach(function (container) {
      container.classList.toggle('active', container.classList.contains(placement));
    });
    wrapper.dataset.lastPlacement = placement;
  }

  function initPinpoint(root, state) {
    root.querySelectorAll('.x-line-placement-wrapper').forEach(function (wrapper) {
      var placement = wrapper.dataset.placement;
      if (placement !== 'cycle') {
        showPlacement(wrapper, placement);
        return;
      }

      showPlacement(wrapper, differentPlacement(null));
      wrapper.parentElement?.addEventListener('mouseenter', function () {
        showPlacement(wrapper, differentPlacement(wrapper.dataset.lastPlacement));
      }, { signal: state.controller.signal });
    });
  }

  function initQuantity(root, state) {
    function updateBounds(input) {
      var form = input.closest('form');
      var value = Number(input.value);
      var decrease = form?.querySelector('[data-quantity-decrease]');
      var increase = form?.querySelector('[data-quantity-increase]');
      if (decrease) decrease.disabled = value <= (Number(input.min) || 1);
      if (increase) increase.disabled = !!input.max && value >= Number(input.max);
    }
    root.querySelectorAll('[data-quantity-input]').forEach(function (input) {
      updateBounds(input);
      input.addEventListener('input', function () { updateBounds(input); }, { signal: state.controller.signal });
      input.addEventListener('change', function () { updateBounds(input); }, { signal: state.controller.signal });
    });
    root.querySelectorAll('[data-quantity-decrease], [data-quantity-increase]').forEach(function (button) {
      button.addEventListener('click', function () {
        var form = button.closest('form');
        var input = form?.querySelector('[data-quantity-input]');
        if (!input) return;
        var min = Number(input.min) || 1;
        var max = input.max ? Number(input.max) : Infinity;
        var step = Number(input.step) || 1;
        var value = Number(input.value) || min;
        input.value = String(Math.min(max, Math.max(min, value + (button.hasAttribute('data-quantity-increase') ? step : -step))));
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }, { signal: state.controller.signal });
    });
  }

  function initSwatchLabels(root, state) {
    root.querySelectorAll('.linked-color-swatches').forEach(function (swatches) {
      var label = swatches.querySelector('[data-active-swatch-label]');
      var active = swatches.querySelector('[aria-current="page"]')?.dataset.title || swatches.dataset.activeTitle;
      function preview(event) {
        var link = event.target.closest('.swatch-link');
        if (label && link) label.textContent = link.dataset.title || active;
      }
      function restore(event) {
        var next = event.relatedTarget?.closest?.('.swatch-link');
        if (label) label.textContent = next && swatches.contains(next) ? next.dataset.title : active;
      }
      swatches.addEventListener('pointerover', preview, { signal: state.controller.signal });
      swatches.addEventListener('focusin', preview, { signal: state.controller.signal });
      swatches.addEventListener('pointerout', restore, { signal: state.controller.signal });
      swatches.addEventListener('focusout', restore, { signal: state.controller.signal });
    });
  }

  function initControlMotion(root, state) {
    if (root.dataset.scrambleLabels !== 'true') return;
    var pointer = matchMedia('(hover: hover) and (pointer: fine)');
    root.addEventListener('pointerover', function (event) {
      if (!pointer.matches) return;
      var control = event.target.closest('.popup-trigger, .faq-card, .product-content-accordion > summary');
      if (!control || control.contains(event.relatedTarget)) return;
      control.querySelector('product-list-command')?.play?.(288);
    }, { signal: state.controller.signal });
    function stop(event) {
      var control = event.target.closest('.popup-trigger, .faq-card, summary');
      if (event.type === 'pointerout' && control?.contains(event.relatedTarget)) return;
      control?.querySelector('product-list-command')?.stop?.();
    }
    root.addEventListener('pointerout', stop, { signal: state.controller.signal });
    root.addEventListener('pointerdown', stop, { signal: state.controller.signal });
    root.addEventListener('keydown', stop, { signal: state.controller.signal });
  }

  function initStickyDetails(root, state) {
    var details = root.querySelector('.sticky-description');
    if (!details) return;
    var headers = Array.from(document.querySelectorAll('.master-header, .announcement-strip'));
    var frame;
    function measure() {
      frame = null;
      var space = parseFloat(getComputedStyle(root).fontSize) || 12;
      var bottom = 0;
      headers.forEach(function (header) {
        var style = getComputedStyle(header);
        if (style.position !== 'fixed' && style.position !== 'sticky') return;
        var rect = header.getBoundingClientRect();
        if (style.position === 'sticky' && rect.top > (parseFloat(style.top) || 0) + 1) return;
        if (rect.width && rect.height && rect.top <= 1 && rect.bottom > 0) bottom = Math.max(bottom, rect.bottom);
      });
      var top = Math.ceil(bottom + space);
      var tall = details.offsetHeight + top + space > innerHeight;
      if (root.style.getPropertyValue('--product-sticky-top') !== top + 'px') root.style.setProperty('--product-sticky-top', top + 'px');
      if (root.dataset.detailsTall !== String(tall)) root.dataset.detailsTall = String(tall);
    }
    function schedule() { if (!frame) frame = requestAnimationFrame(measure); }
    var observer = new ResizeObserver(schedule);
    [details].concat(headers).forEach(function (element) { observer.observe(element); });
    window.addEventListener('resize', schedule, { signal: state.controller.signal });
    window.addEventListener('scroll', schedule, { passive: true, signal: state.controller.signal });
    state.cleanups.push(function () { observer.disconnect(); cancelAnimationFrame(frame); });
    measure();
  }

  function initFitGuide(root, state) {
    function sizeKey(value) {
      var key = String(value || '').trim().toUpperCase().replace(/[\s_-]+/g, '');
      return ({ SMALL: 'S', MEDIUM: 'M', LARGE: 'L', EXTRASMALL: 'XS', EXTRALARGE: 'XL', EXTRAEXTRALARGE: 'XXL' })[key] || key;
    }
    function markSize() {
      var picker = root.querySelector('[data-product-option-picker]');
      var input = picker?.querySelector('[data-size-option] input:checked, [data-size-option] select');
      var selected = picker?.dataset.sizePending === 'true' ? '' : sizeKey(input?.value);
      root.querySelectorAll('[data-fit-size]').forEach(function (model) {
        model.dataset.fitSelected = String(!!selected && sizeKey(model.dataset.fitSize) === selected);
      });
    }
    document.addEventListener('variant:change', function (event) {
      if (event.detail?.sectionId === root.dataset.sectionId) markSize();
    }, { signal: state.controller.signal });
    markSize();
  }

  function init(root) {
    if (!root || root.dataset.productUiInitialized === 'true') return;
    root.dataset.productUiInitialized = 'true';
    var state = { controller: new AbortController(), cleanups: [] };
    instances.set(root, state);
    initPopups(root, state);
    initAccordions(root, state);
    initPinpoint(root, state);
    initQuantity(root, state);
    initSwatchLabels(root, state);
    initControlMotion(root, state);
    initStickyDetails(root, state);
    initFitGuide(root, state);
  }

  function initAll(scope) {
    if (scope?.matches?.('[data-product-section]')) init(scope);
    (scope || document).querySelectorAll('[data-product-section]').forEach(init);
  }

  window.ProductUI2026 = { init: initAll };
  document.addEventListener('shopify:section:unload', function (event) {
    instances.forEach(function (state, root) {
      if (root !== event.target && !event.target.contains(root)) return;
      state.controller.abort(); state.cleanups.forEach(function (cleanup) { cleanup(); });
      delete root.dataset.productUiInitialized; instances.delete(root);
    });
  });
  initAll(document);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); }, { once: true });
  }
  document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
  document.addEventListener('shopify:block:select', function (event) {
    var root = event.target.closest?.('[data-product-section]');
    if (!root) return;
    updateAccordionClasses(root);
    var accordion = event.target.closest('.product-content-accordion');
    if (accordion) accordion.open = true;
    var model = event.target.closest('[data-fit-size]');
    var state = instances.get(root);
    if (model && state?.sizingModal && !model.closest('dialog').open) {
      state.sizingModal.open(root.querySelector('.size_guide'));
      state.editorOpenedGuide = true;
    }
  });
  document.addEventListener('shopify:block:deselect', function (event) {
    var root = event.target.closest?.('[data-product-section]');
    var state = instances.get(root);
    if (state?.editorOpenedGuide) {
      state.sizingModal.close(false);
      state.editorOpenedGuide = false;
    }
  });
})();
